const API_PATH_PREFIX = "/api/v1/admin";
const buildTimeApiUrl = (import.meta.env.VITE_API_URL || "")
  .trim()
  .replace(/\/+$/, "");

/**
 * Resolve the API base URL. Prefers the build-time VITE_API_URL env var.
 * When the app is served from the static bucket (kira.<env>.kaptioapis.com)
 * without a build-time value, derive the API host so requests go to
 * kira-api.<env>.kaptioapis.com.
 */
function getRuntimeApiBaseUrl(): string {
  if (buildTimeApiUrl) return buildTimeApiUrl;
  if (typeof window !== "undefined" && window.location?.hostname) {
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    const match = host.match(/^kira\.(.+)$/);
    if (match) return `${protocol}//kira-api.${match[1]}${API_PATH_PREFIX}`;
  }
  return API_PATH_PREFIX;
}

export function getApiBaseUrl(): string {
  return getRuntimeApiBaseUrl();
}

export function getApiRootUrl(): string {
  if (buildTimeApiUrl) {
    return buildTimeApiUrl.replace(/\/api\/v1\/admin\/?$/, "");
  }
  if (typeof window !== "undefined" && window.location?.hostname) {
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    const match = host.match(/^kira\.(.+)$/);
    if (match) return `${protocol}//kira-api.${match[1]}`;
  }
  return "";
}
